module.exports = __webpack_public_path__ + "static/media/leal_role_chat.c4873e8a.svg";